'use client';

import React, { useState } from 'react';
import { appDirLogout } from '~/api/appDir/user';
import BaseNav from '~/components/Chrome/Header/Mobile/BaseNav';
import { MobileNavOverlay } from '~/components/Chrome/Header/Mobile/MobileNavElements';
import MobileMenuItem from '~/components/MobileMenuItem';
import { dispatchLogoutEvent } from '~/lib/events/customEvents';

const disableScrolling = (which: 'left' | 'right' | 'search') => {
  document.body.classList.add('nav-open', which);
};

const enableScrolling = () => {
  document.body.classList.remove('nav-open', 'left', 'right');
};

interface Props {
  avatar: React.ReactNode;
  children?: React.ReactNode;
}

const MobileRightNav: React.FC<Props> = ({ avatar, children }) => {
  const [open, setOpen] = useState(false);

  function toggleRight() {
    if (open) {
      enableScrolling();
    } else {
      disableScrolling('left');
    }
    setOpen(!open);
  }

  function handleLogout() {
    appDirLogout();
    setOpen(false);
    dispatchLogoutEvent();
  }

  return (
    <>
      <button
        onClick={toggleRight}
        type="button"
        aria-label="Open account menu"
      >
        {avatar}
      </button>

      <BaseNav
        style={{
          margin: 0,
          right: open ? 0 : -270,
        }}
      >
        {children}

        <ul>
          <MobileMenuItem
            text="Logout"
            onClick={handleLogout}
            chevron={false}
            variant="dark"
          />
        </ul>
      </BaseNav>

      {open && (
        <MobileNavOverlay
          style={{
            right: open ? 270 : undefined,
          }}
          onClick={toggleRight}
        />
      )}
    </>
  );
};

export default MobileRightNav;
